<script setup>  
  import { vIcon } from '../../utils/icons';
  
  import { useTestStore } from '../../stores/TestStore';
  const testStore = useTestStore();

  const filtros = JSON.parse(document.getElementById("filtros").value);
</script>

<template>
  <div v-for="filtro in filtros" :key="filtro.id" class="flex border-b items-center py-2">
    <div class="h-12 w-12 border flex justify-center items-center hover:bg-green-200 mr-4 cursor-pointer transition-colors"
      @click="testStore.toggle_filtro(filtro)" :class="[(testStore.filtro_id(filtro.id).length > 0) ? 'text-green-600' : '']">
      <i v-html='vIcon' v-if="testStore.filtro_id(filtro.id).length > 0"></i>
    </div>
    <div class="w-64">{{ filtro.nombre }}</div>
    <div class="w-64">{{ filtro.tipo }}</div>
    <div class="w-64" v-if="filtro.user_id">Propio</div>
    <div class="w-64" v-else>Genérico</div>
    
    <div v-if="filtro.tipo == 'selector'">
      <span v-for="(select, index) in filtro.select_values" :key="index"
        class="ml-2 border p-1 px-2 rounded-xl">{{ select }}</span>
    </div>
    <div v-if="filtro.tipo == 'numero'">
      <span class="mx-3"><b>Min:</b> {{ filtro.integer_values.min }}</span>
      <span class="mx-3"><b>Max:</b> {{ filtro.integer_values.max }}</span>
      <span class="mx-3"><b>Salto:</b> {{ filtro.integer_values.salto }}</span>
    </div>
  </div>

</template>


<style lang="scss">

</style>